'use client';

import * as React from 'react';
/**
 * @ignore - internal component.
 */
export const TreeViewStyleContext = /*#__PURE__*/React.createContext({
  classes: {},
  slots: {},
  slotProps: {}
});
if (process.env.NODE_ENV !== "production") TreeViewStyleContext.displayName = "TreeViewStyleContext";
export const useTreeViewStyleContext = () => {
  return React.useContext(TreeViewStyleContext);
};